import { render, staticRenderFns } from "./SavedPlanUnallocUnitCard.vue?vue&type=template&id=108df677&"
import script from "./SavedPlanUnallocUnitCard.vue?vue&type=script&lang=js&"
export * from "./SavedPlanUnallocUnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports